export class HttpError extends Error {
  status = 'unknown';

  headers: Record<string, unknown> = {};

  response: unknown = {};

  errorType = 'other';

  method: string;

  constructor(method: string) {
    super();
    this.method = method;
  }

  get message(): string {
    return `Request failed with code ${this.status} on method ${this.method}`;
  }

  setType(errorType: string): void {
    this.errorType = errorType;
  }

  setStatus(status?: number): void {
    this.status = String(status);
  }

  setHeaders(headers?: Record<string, unknown>): void {
    this.headers = headers ?? {};
  }

  setResponse(response: unknown): void {
    this.response = response;
  }
}
